<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="border-bottom px-4">
    <button
      [cSidebarToggle]="sidebarId()"
      cHeaderToggler
      class="btn d-grid place-items-center"
      toggle="visible"
      style="margin-inline-start: -14px"
      aria-label="Toggle sidebar navigation"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <c-header-nav class="ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
      <!-- Botón campana de alertas (solo Gestor/Editor) -->
      <!-- @if (isGestorOrEditor) {
        <app-alerts-panel />
        <div class="nav-item py-1">
          <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
        </div>
      } -->
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown
    alignment="end"
    [popperOptions]="{ placement: 'bottom-end' }"
    variant="nav-item"
  >
    <button
      [caret]="false"
      cDropdownToggle
      class="py-0 pe-0 user-toggle-btn"
      aria-label="Open user menu"
    >
      <div class="d-flex align-items-center gap-3">
        <div class="d-flex flex-column align-items-end lh-sm">
          <span class="fw-semibold text-body small">{{ fullName() }}</span>
          <span
            class="text-secondary"
            style="font-size: 0.72rem; text-transform: capitalize"
            >{{ userRole() }}</span
          >
        </div>
        <c-avatar
          shape="rounded-1"
          [size]="'md'"
          src="assets/img/avatar.png"
          status="success"
          textColor="primary"
          alt="User avatar"
        />
      </div>
    </button>
    <ul cDropdownMenu class="w-auto">
      <li>
        <button cDropdownItem (click)="onLogout()">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          Cerrar sesión
        </button>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button
      [caret]="false"
      cDropdownToggle
      aria-label="Open theme picker"
      class="d-grid place-items-center"
    >
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
        <button
          (click)="colorMode.set(mode.name)"
          [active]="colorMode() === mode.name"
          cDropdownItem
          class="d-flex align-items-center"
        >
          <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
          {{ mode.text }}
        </button>
      }
    </div>
  </c-dropdown>
</ng-template>
